export const panelStyle = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--bg-card)',
  padding: 12,
};

export const panelHeadStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: 10,
  alignItems: 'center',
  marginBottom: 10,
};

export const panelTitleStyle = { fontSize: 15, color: 'var(--text)', fontWeight: 950 };
export const panelSubStyle = { marginTop: 4, fontSize: 12, color: 'var(--text-sub)', fontWeight: 700 };

export const ruleListStyle = {
  display: 'grid',
  gap: 8,
};

export const ruleRowStyle = {
  display: 'grid',
  gridTemplateColumns: 'minmax(150px, 1fr) repeat(3, minmax(150px, auto)) auto',
  gap: 8,
  alignItems: 'center',
  padding: 8,
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--bg)',
  overflowX: 'auto',
};

export const departmentLabelStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  color: 'var(--text)',
  fontWeight: 900,
  minWidth: 0,
};

export const employeeCountStyle = {
  color: 'var(--text-muted)',
  fontSize: 11,
  fontWeight: 850,
  whiteSpace: 'nowrap',
};

export const rulePeriodStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 5,
  color: 'var(--text-sub)',
  fontSize: 12,
  fontWeight: 850,
  minWidth: 0,
};

export const fieldCaptionStyle = {
  color: 'var(--text-muted)',
  minWidth: 28,
};

export const fieldStackStyle = {
  display: 'grid',
  gap: 4,
  color: 'var(--text-sub)',
  fontSize: 12,
  fontWeight: 850,
};

export const periodFieldStyle = {
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) 86px',
  gap: 6,
  alignItems: 'center',
};

export const manualFormStyle = {
  display: 'grid',
  gap: 10,
  marginTop: 12,
};

export const manualRowStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 10,
  alignItems: 'end',
};

export const manualEmployeeFieldStyle = {
  flex: '0 1 190px',
  minWidth: 150,
};

export const manualDateFieldStyle = {
  flex: '0 0 150px',
};

export const manualPeriodFieldStyle = {
  flex: '0 0 155px',
};

export const manualActionsStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
};
